import { Fragment, ReactElement, useEffect, useRef, useState } from "react";
import { IColumn, IRealtimeData } from "../../../../../types";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import StyledTableRow from "../../../../../components/styledTableRow";
import {
  IDashboard,
  IDashboardComponent,
  IEventCondition,
  IEventConfig,
  IEventData,
  Severity
} from "../../../types";
import { DateTime } from "luxon";
import { getDefaultLocaleConfig } from "../../../../../configuration/configuration";
import { getFloatValue } from "../../../../../system/utils";

interface IProps {
  realtime: Record<string, any>;
  component: IDashboardComponent<IEventConfig>;
  dashboard: IDashboard;
}

const columns: IColumn[] = [
  { id: "datetime", label: "Datetime", minWidth: 100 },
  // { id: "severity", label: "Severity", minWidth: 50 },
  { id: "message", label: "Message", minWidth: 400 },
];

const getValue = (condition: IEventCondition, realtime: Record<string, IRealtimeData>): number | null => {
  if (condition.type === "VALUE") {
    return condition.value as number;
  }

  return condition.type === "TAG" && realtime[condition.value] ? getFloatValue(realtime[condition.value], 0) : null;
};

const EventComponent = ({ component, realtime, dashboard }: IProps ): ReactElement => {
  const [ events, setEvents ] = useState<IEventData[]>([]);
  const status = useRef<Record<string, boolean>>({});

  useEffect(() => {
    status.current = {};
    setEvents([]);
  },  [component]);


  useEffect(() => {
    const newEvents = [ ...events ];
    const datetime = DateTime.now().toFormat(getDefaultLocaleConfig().timeFormat);

    component.config.variables.forEach(v => {
      v.conditions.forEach(e => {
        const valueA = realtime[v.code]?.Value;
        const valueB = getValue(e, realtime);

        if (valueA && valueB) {

          const evalCondition = e.comparison === "=" && valueA === valueB
            || e.comparison === "<" && valueA < valueB
            || e.comparison === ">" && valueA > valueB
            || e.comparison === ">=" && valueA >= valueB
            || e.comparison === "<=" && valueA <= valueB
            || e.comparison === "<>" && valueA !== valueB;

          if (!status.current[e.hash] && evalCondition) {
            status.current[e.hash] = true;
            newEvents.unshift({ datetime, severity: e.severity, message: e.title });
          } else if (status.current[e.hash] && !evalCondition) {
            status.current[e.hash] = false;
          }
        }
      });
    });

    setEvents(newEvents.slice(0, 20 - newEvents.length));
  },  [realtime, component]);

  return (
    <Table stickyHeader={true} size="small"  >
      <TableHead>
        <TableRow >
          {columns.map((column, index) =>
            <TableCell
              className="table-header p-1"
              key={`${column.id}-${index}`}
              align={column.align}
              style={{ minWidth: column.minWidth, fontSize: `${dashboard.customConfig.fontSize * 14}px` }}>
              {column.id !== "actions" ? column.label : <Fragment/>}
            </TableCell>
          )}
        </TableRow>
      </TableHead>
      <TableBody>
        {events.map((row: IEventData, index: number) => {
          let severity = "";

          if(row.severity ===  Severity.Medium) {
            severity = "severity-medium";
          } else if(row.severity ===  Severity.High) {
            severity = "severity-high";
          }

          return (
            <StyledTableRow hover={true} role="checkbox" tabIndex={-1} key={`evt-row-${index}`} className={severity}>
              {columns.map((column: IColumn) => {
                const value = row[column.id as keyof IEventData];

                // if (column.id === "severity"){
                //   return (
                //     <TableCell key={`${column.id}-${index}`} align={column.align} >
                //       {value === Severity.Low && <ErrorOutlineIcon style={{ fontSize: `${1 + dashboard.customConfig.fontSize * 18}px` }}/>}
                //       {value === Severity.Medium && <WarningIcon style={{ fontSize: `${dashboard.customConfig.fontSize * 18}px` }}/>}
                //       {value === Severity.High && <DangerousIcon style={{ fontSize: `${dashboard.customConfig.fontSize * 18}px` }}/>}
                //     </TableCell>
                //   );
                // }

                return (
                  <TableCell key={`${column.id}-${index}`} align={column.align} style={{ fontSize: `${dashboard.customConfig.fontSize * 16 }px` }}>
                    {value}
                  </TableCell>
                );
              })}
            </StyledTableRow>
          );
        })}

      </TableBody>
    </Table>
  );
};

export default EventComponent;
